var _excluded = ["className", "isOpen", "onRest", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef, useEffect, useState } from 'react';
import { string, bool, func, node } from 'prop-types';
import classNames from 'classnames';
export var Collapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    isOpen = _ref.isOpen,
    onRest = _ref.onRest,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var internalRef = useRef();
  var collapse = ref !== null && ref !== void 0 ? ref : internalRef;
  var _useState = useState(!isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  useEffect(function () {
    if (isOpen) {
      setIsHidden(false);
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: collapse,
    className: classNames('ffe-collapse', className, {
      'ffe-collapse--open': isOpen,
      'ffe-collapse--hidden': isHidden
    }),
    onTransitionEnd: function onTransitionEnd(e) {
      if (e.target === collapse.current && e.propertyName === 'grid-template-rows') {
        if (onRest) {
          onRest();
        }
        if (!isOpen) {
          setIsHidden(true);
        }
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "ffe-collapse__inner"
  }, children));
});
Collapse.displayName = 'Collapse';
Collapse.propTypes = {
  className: string,
  isOpen: bool,
  onRest: func,
  /** The content to appear when expanded */
  children: node.isRequired
};